export const PROTEKTOR_VIEW = 'view';
export const PROTEKTOR_UPDATE = 'update';
export const PROTEKTOR_CREATE = 'create';
export const PROTEKTOR_DELETE = 'delete';
